export default "__VITE_ASSET__BbGS7npv__"